import { Stack, Typography } from '@mui/material';

import { useLocalization } from '../../../localization';
import RadioSelect from '../radio/RadioSelect';

const languageOptions = [
  {
    label: 'EN',
    value: 'en',
  },
  {
    label: 'DA',
    value: 'da',
  },
  {
    label: 'SV',
    value: 'sv',
  },
  {
    label: 'NO',
    value: 'no',
  },
];

const LanguageSelection = () => {
  const { updateLocale, locale, t } = useLocalization();
  const onChange = (language: string) => {
    updateLocale(language);
  };

  return (
    <Stack style={{ width: 100, margin: '0.5rem' }} spacing={1}>
      <Typography variant="h5">{t('navigation.secondaryMenu.language')}</Typography>
      <RadioSelect options={languageOptions} onChange={onChange} defaultValue={locale} />
    </Stack>
  );
};

export default LanguageSelection;
